import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../../store';
import SliderListItem from '../../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../../store/extensions';

const ImageElementShadowOpacityListItem = (props) => {
    const { shadowSettingsOpacity, updateImageElement, index } = props;

    const onShadowOpacityChange = (value) => {
        previewHistoryBatch.start();
        updateImageElement(index, { shadowSettings: { opacity: value } });
    };

    return (
        <SliderListItem
            title='Opacity'
            value={shadowSettingsOpacity}
            displayMultiplier={100}
            min={0}
            max={100}
            step={1}
            onValueChange={onShadowOpacityChange}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const imageElement = (state.createPreview.present.videoSettings.elements.imageElements || state.createPreview.present.videoSettings.elements.images)[ownProps.index];
    const shadowSettings = imageElement?.shadowSettings || {};
    return { shadowSettingsOpacity: shadowSettings.opacity };
}

const mapDispatchToProps = (dispatch) => {
    const updateImageElement = (index, properties) => dispatch(createActions.updateImageElement(index, properties));
    return { updateImageElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageElementShadowOpacityListItem);
